import {
  ArrowDownOutlined,
  Box,
  Button,
  Flex,
  Form,
  Modal,
  useForm,
} from '@ergolabs/ui-kit';
import React, { FC, useState } from 'react';
import styled from 'styled-components';

import { submitContributionTxErgopay } from '../../../../api/submitContributionTx/submitContributionTx';
import { AssetControlFormItem } from '../../../../common/components/AssetControl/AssetControl';
import { TxId } from '../../../../common/types';
import { ContributionFormModel } from './ContributionFormModel';

export interface ContributionErgoPayModalProps {
  readonly value: Required<ContributionFormModel>;
  readonly onClose: (p: TxId) => void;
  readonly proxyNft: string;
  readonly whitelistTokenId: string;
}

const ArrowContainer = styled(Flex.Item)`
  height: 4px;
  position: relative;
  z-index: 2;
`;

const ArrowBox = styled(Box)`
  background: #141414;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const ContributionErgoPayModal: FC<ContributionErgoPayModalProps> = ({
  value,
  proxyNft,
  onClose,
  whitelistTokenId,
}) => {
  const form = useForm<Required<ContributionFormModel>>(value);
  const [loading, setLoading] = useState<boolean>(false);

  const contribute = () => {
    setLoading(true);
    submitContributionTxErgopay({
      whitelistTokenId: whitelistTokenId,
      proxyNft: proxyNft,
      vestingAmount: value.to,
      sigUsdAmount: value.from,
    }).subscribe((txId) => {
      onClose(txId);
      setLoading(false);
    });
  };

  return (
    <Form form={form}>
      <Modal.Title>Contribution confirmation</Modal.Title>
      <Modal.Content width="100%" maxWidth={400}>
        <Flex col>
          <AssetControlFormItem amountName="from" tokenName="fromAsset" />
          <ArrowContainer>
            <ArrowBox height={32} width={32} borderRadius="s">
              <Flex align="center" justify="center" stretch width="100%">
                <ArrowDownOutlined
                  style={{ color: 'var(--spectrum-primary-text)' }}
                />
              </Flex>
            </ArrowBox>
          </ArrowContainer>
          <Flex.Item marginBottom={6}>
            <AssetControlFormItem
              amountName="to"
              tokenName="toAsset"
              readonly
            />
          </Flex.Item>
          <Button
            size="large"
            htmlType="button"
            type="primary"
            width="100%"
            onClick={contribute}
            loading={loading}
          >
            Confirm
          </Button>
        </Flex>
      </Modal.Content>
    </Form>
  );
};
